import { Link } from "@tanstack/react-router";
import { OPERATOR } from "@/features/legal/content";
import { useI18n } from "@/i18n";
import { cn } from "@/lib/cn";

/** The only place outside the legal pages where the operating company is named. */
export function SiteFooter({ className }: { className?: string }) {
  const { t, num } = useI18n();
  return (
    <footer className={cn("border-t px-4 py-4 text-xs text-muted-foreground sm:px-6", className)}>
      <div className="mx-auto flex max-w-5xl flex-col items-center justify-between gap-2 sm:flex-row">
        <p>
          © {num(new Date().getFullYear())} Zeeta ·{" "}
          {t("legal.productOf", { company: OPERATOR.name })}
        </p>
        <nav className="flex gap-4" aria-label={t("legal.nav")}>
          <Link to="/terms" className="hover:text-foreground">
            {t("legal.terms")}
          </Link>
          <Link to="/privacy" className="hover:text-foreground">
            {t("legal.privacy")}
          </Link>
        </nav>
      </div>
    </footer>
  );
}
